import { createFileRoute } from '@tanstack/react-router';

/**
 * The directory with no partner's sheet open.
 *
 * It renders nothing: the page — heading, filters, category rows and the sheet itself — is the
 * shell's (see `partner-ngos.tsx`), which is what keeps opening and closing the sheet from
 * remounting the directory behind it. This route exists so that closed is a real URL rather than the
 * absence of one, and so `<Outlet />` has something to match when it is.
 */
export const Route = createFileRoute('/www/partner-ngos/')({
	component: () => null,
});
